import { compose } from 'redux';
import { connect } from 'react-redux';

import routeDependencies from 'utilities/routeDependencies';
import { loadable } from 'modules/layout';

import InfoCategoryPage from '../../components/InfoCategoryPage';

import { infoCategoryDetailRequest } from '../../services/actions';
import { selectInfoCategoriesDetailPending } from '../../services/selectors';

export default compose(
    connect(
        (state, { match: { params } }) => ({
            id: params.id,
            showLoader: selectInfoCategoriesDetailPending(state),
        }),
        (dispatch, { match: { params } }) => ({
            read: () => {
                dispatch(infoCategoryDetailRequest(params.id));
            },
        }),
    ),
    routeDependencies(),
    loadable,
)(InfoCategoryPage);
